import { GET_FAVORITES_FILTERED_DATA} from './actionTypes'

export default (objectType, boardId) => ({
  type: GET_FAVORITES_FILTERED_DATA,
  payload: {
    objectType,
    boardId
  }
})